module.exports = __webpack_public_path__ + "img/linktg.ceb99c9.svg";